import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const LOGO_DARK = '/zippedi_only_letters_white.png';
const LOGO_LIGHT = '/zippedi_only_letters.png';

export default function Logo({ onClick, height = 46, sx }) {
  const theme = useTheme();
  const src = theme.palette.mode === 'dark' ? LOGO_DARK : LOGO_LIGHT;

  return (
    <Box
      component="img"
      src={src}
      alt="Zippedi"
      onClick={onClick}
      sx={{
        height,
        width: 'auto',
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
        display: 'block',
        borderRadius: '7px',
        padding: '5px',
        ...sx,
      }}
    />
  );
}
